// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"yR","facetClass":"zR","tooltipWrapper":"AR","icon":"BR","tooltip":"CR","content":"DR"};